import { type ComponentProps } from 'react';

import {
	Checkbox as ArkCheckbox,
	type CheckboxGroupProps as ArkCheckboxGroupProps
} from '@ark-ui/react';
import { Check } from '@phosphor-icons/react/dist/csr/Check';

import type { ActionColor, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type CheckboxCardsProps = Omit<ArkCheckboxGroupProps, 'color'> & {
	size?: Scale3;
	variant?: 'surface' | 'classic';
	color?: ActionColor;
	highContrast?: boolean;
};

function CheckboxCardsRoot({
	className,
	size = '2',
	variant = 'surface',
	color = 'accent',
	highContrast,
	...props
}: CheckboxCardsProps) {
	return (
		<ArkCheckbox.Group
			className={cn('pt-checkbox-cards', className)}
			data-size={size}
			data-variant={variant}
			data-accent-color={color}
			data-high-contrast={highContrast ? '' : undefined}
			{...props}
		/>
	);
}

function CheckboxCardsItem({
	className,
	children,
	...props
}: ComponentProps<typeof ArkCheckbox.Root>) {
	return (
		<ArkCheckbox.Root {...props} className={cn('pt-checkbox-cards-item', className)}>
			{children}
			<ArkCheckbox.Control className="pt-checkbox-cards-control">
				<ArkCheckbox.Indicator>
					<Check size={12} weight="bold" />
				</ArkCheckbox.Indicator>
			</ArkCheckbox.Control>
			<ArkCheckbox.HiddenInput />
		</ArkCheckbox.Root>
	);
}

const CheckboxCards = Object.assign(CheckboxCardsRoot, {
	Root: CheckboxCardsRoot,
	Item: CheckboxCardsItem
});

export { CheckboxCards, type CheckboxCardsProps };
